import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../core/domain/events/domain_event_provider';
import { ResourceEvent } from './resource.events';

@Injectable({ providedIn: 'root' })
export class ResourceEventProvider extends DomainEventProvider<ResourceEvent> {}
